module.exports = __webpack_public_path__ + "img/loading.222cd1c9.svg";